import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import { RemoteFetchUserInputPlanning } from "../../../data/usecases/user-input-planning/remote-fetch-user-input-planning";
import Endpoints from "../../../domain/endpoints";
import { UserInputPlanningModel } from "../../../domain/models/user-input-acknowledgement/user-input-planning-model";
import { FetchState } from "../../../domain/models/fetch-state";
import Swal from "sweetalert2";
import { FetchUserInputPlanning } from "../../../domain/useages/user-input-planning/fetch-user-input-planning";
import moment from "moment";
import dayjs from "dayjs";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchUserInputPlanningInterface {
  fetchUserInputPlanning: Function;
  userInputData: UserInputPlanningModel;
  fetchInputState: FetchState;
  currentPage: number;
  handlePageNumber: Function;
  filterStore: FetchUserInputPlanning.Params;
}

const initialStates = {
  userInputData: {} as UserInputPlanningModel,
  fetchInputState: FetchState.DEFAULT,
  currentPage: 1,
  filterStore: {
    zone_ids: [],
    region_ids: [],
    area_ids: [],
    headquarter_ids: [],
    brick_ids: [],
    month_year: moment(dayjs(new Date()).toString()).format("yyMM"),
    customer_type_id: "",
    page: 1,
  } as FetchUserInputPlanning.Params,
};

export const useFetchUserInputPlanningSlice: StateCreator<
  FetchUserInputPlanningInterface
> = (set, get) => ({
  ...initialStates,
  fetchUserInputPlanning: async (payload: any) => {
    set(() => ({ fetchInputState: FetchState.LOADING }));

    const axiosHttpClient = AxiosHttpClient.getInstance();


     const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
     const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteFetchBrandsMaster = new RemoteFetchUserInputPlanning(
      `${BASE_URL}${Endpoints.USER_INPUT_PLANNING}`,
      axiosHttpClient
    );

    // let fiters = {
    //   zone_ids: payload.zone_ids,
    //   region_ids: payload.region_ids,
    //   area_ids: payload.area_ids,
    //   headquarter_ids: payload.headquarter_ids,
    //   brick_ids: payload.brick_ids,
    //   month_year: payload.date,
    //   customer_type_id: payload.customer_type_id,
    //   page: payload.page,
    // };

    let result = await remoteFetchBrandsMaster.fetch(get().filterStore);
    if (result.success) {
      set(() => ({ userInputData: result.data }));
      set(() => ({ fetchInputState: FetchState.SUCCESS }));
    } else {
      set(() => ({ fetchInputState: FetchState.ERROR }));
      Swal.fire({
        icon: "error",
        text: "There Was Some Error in getting the Inputs",
        timer: 3000,
        customClass: {
          container: "swal2-style",
        },
      });
    }
  },
  handlePageNumber: (pageNo: number) => {
    set(() => ({ currentPage: pageNo }));
  },
});
